import React, { useState } from 'react';
import { Mail, ExternalLink } from 'lucide-react';

interface ProtectedEmailProps {
  className?: string;
  showIcon?: boolean;
  variant?: 'button' | 'link' | 'text';
  size?: 'sm' | 'md' | 'lg';
}

const ProtectedEmail: React.FC<ProtectedEmailProps> = ({ 
  className = '', 
  showIcon = true, 
  variant = 'link',
  size = 'md'
}) => {
  const [revealed, setRevealed] = useState(false);
  
  // Obfuscated email parts to prevent scraping
  const emailParts = ['crp', '@', 'treuhand-beratungen', '.ch'];
  const email = emailParts.join('');
  
  const handleClick = () => {
    setRevealed(true);
    // Small delay to show the email before opening mailto
    setTimeout(() => {
      window.location.href = `mailto:${email}`;
    }, 100);
  };

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const variantClasses = {
    button: 'inline-flex items-center px-4 py-2 bg-accent-orange text-white hover:bg-accent-orange-dark transition-colors',
    link: 'text-accent-orange hover:text-accent-orange-dark transition-colors cursor-pointer',
    text: 'text-gray-700 hover:text-accent-orange transition-colors cursor-pointer'
  };

  if (revealed) {
    return (
      <span className={`${sizeClasses[size]} ${className}`}>
        {showIcon && <Mail className="w-4 h-4 mr-2 inline" />}
        {email}
        <ExternalLink className="w-3 h-3 ml-1 inline" />
      </span>
    );
  }

  return (
    <span 
      className={`${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
      title="Click to reveal email address"
    >
      {showIcon && <Mail className="w-4 h-4 mr-2 inline" />}
      {variant === 'button' ? 'Email anzeigen' : 'Email anzeigen'}
    </span>
  );
};

export default ProtectedEmail;
